import React, { Component } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import bannerImage from "../../Images/Banner/extracurriculum.webp";
import extraCurriculum from "../../Images/campus/extracurriculum-cultural.webp"
import Sports from "../../Images/sports/sports-2.webp";
import Activity from "../../Images/commonimg/activity.webp"
import Event from "../../Images/commonimg/event.webp";
import Social from "../../Images/commonimg/social.webp";
import Cultural from "../../Images/commonimg/cultural.webp";

const ExtraCurricular = () => {
    return (
        <>
            <title>Extra-Curricular Activities & Student Clubs | ISBM University</title>
            <meta
                name="description"
                content="ISBM University offers a wide range of extra-curricular options — from cultural events to sports and clubs. Grow personally and socially. Get involved today."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Extra Curricular</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    Extra Curricular
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section class="ptb-50">
                <div class="container-xxl">
                    <h2 class="section-title modern-title text-center text-blue">Creative & Cultural Expression</h2>
                    <p class="text-center mx-auto">Various clubs celebrate diversity through dance, music, drama, and art, allowing students to showcase their talents and participate in cultural events.</p>
                    <div class="row g-4 mt-5">

                        <div class="col-lg-4 col-12">
                            <div class="culture-card h-100 shadow d-flex flex-column">
                                <div class="cultural-card-icon d-flex justify-content-center align-items-center mb-4">
                                    <i className="ti ti-masks-theater cutural-icon"></i>
                                </div>
                                <h3 class="fw-bold mb-2">Cultural Clubs</h3>
                                <p>Celebrate diversity through dance, music, drama, and art, offering platforms for talent and cultural participation.</p>
                                <div class="card-highlights mb-3">
                                    <span class="highlight-item">Dance</span>
                                    <span class="highlight-item">Music</span>
                                    <span class="highlight-item">Drama</span>
                                    <span class="highlight-item">Art</span>
                                    <span class="highlight-item">Theatre</span>
                                    <span class="highlight-item">Photography</span>
                                    <span class="highlight-item">Cultural Fests</span>
                                </div>
                                <div class="culture-image-container">
                                    <img src={Event} alt="Cultural Activities" class="culture-image" />
                                    {/* <div class="image-overlay d-flex align-items-center justify-content-center">
                                        <a href="#" class="btn btn-outline-light">Explore Clubs <i class="ti ti-arrow-right ms-2"></i></a>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-12">
                            <div class="culture-card h-100 shadow d-flex flex-column">
                                <div class="cultural-card-icon d-flex justify-content-center align-items-center mb-4">
                                    <i className="ti ti-brain cutural-icon"></i>
                                </div>
                                <h3 class="fw-bold mb-2">Literary Activities</h3>
                                <p>Students can engage in literary clubs that focus on writing, debating, and public speaking, enhancing their communication skills and confidence.</p>
                                <div class="card-highlights mb-3">
                                    <span class="highlight-item">Writing</span>
                                    <span class="highlight-item">Debating</span>
                                    <span class="highlight-item">Public Speaking</span>
                                    <span class="highlight-item">Elocution</span>
                                    <span class="highlight-item">Quizzes</span>
                                </div>
                                <div class="culture-image-container">
                                    <img src={Activity} alt="Literary Activities" class="culture-image" />
                                    {/* <div class="image-overlay d-flex align-items-center justify-content-center">
                                        <a href="#" class="btn btn-outline-light">View Events <i class="ti ti-arrow-right ms-2"></i></a>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-12">
                            <div class="culture-card h-100 shadow d-flex flex-column">
                                <div class="cultural-card-icon d-flex justify-content-center align-items-center mb-4">
                                    <i className="ti ti-music cutural-icon"></i>
                                </div>
                                <h3 class="fw-bold mb-2">Festivals & Events</h3>
                                <p>The University hosts various festivals, competitions, and annual events that encourage student participation, collaboration, and celebration of achievements.</p>
                                <div class="card-highlights mb-3">
                                    <span class="highlight-item">Celebrations</span>
                                    <span class="highlight-item">Competitions</span>
                                    <span class="highlight-item">Workshops</span>
                                    <span class="highlight-item">Collaborations</span>
                                    <span class="highlight-item">Annual Fest</span>
                                </div>
                                <div class="culture-image-container">
                                    <img src={Cultural} alt="Festivals & Events" class="culture-image" />
                                    {/* <div class="image-overlay d-flex align-items-center justify-content-center">health-icon mb-3
                                        <a href="#" class="btn btn-outline-light">See Calendar <i class="ti ti-arrow-right ms-2"></i></a>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="ptb-50 bg-light-purple">
                <div class="container-xxl">
                    <div class="text-center mb-5">
                        <h2 class="section-title modern-title text-blue mt-3">Health, Teamwork & Social Responsibility</h2>
                        <p class="section-subtitle mx-auto">Promoting holistic growth through physical well-being and community impact</p>
                    </div>

                    <div class="row g-4">
                        <div class="col-12">
                            <div class="modern-health mb-5">
                                <div class="row g-0 h-100">
                                    <div class="col-md-6 order-md-1 position-relative">
                                        <div class="health-image-container">
                                            <div class="health-background-block bg-purple"></div>
                                            <img src={Sports} alt="Sports Activities" class="health-image" />
                                        </div>
                                    </div>
                                    <div class="col-md-6 order-md-2">
                                        <div class="health-content px-5 py-3">
                                            <div class="health-icon mb-3">
                                                <i class="ti ti-olympics"></i>
                                            </div>
                                            <h3 class="fw-bold mb-3">Sports Teams</h3>
                                            <p class="mb-4">The University encourages participation in various sports, promoting teamwork and physical fitness through competitions and tournaments.</p>

                                            <div class="health-highlights mb-3">
                                                <div class="health-highlight-item">
                                                    <i class="ti ti-check"></i> Inter-college tournaments
                                                </div>
                                                <div class="health-highlight-item">
                                                    <i class="ti ti-check"></i> Professional coaching
                                                </div>
                                                <div class="health-highlight-item">
                                                    <i class="ti ti-check"></i> Annual sports fest
                                                </div>
                                                <div class="health-highlight-item">
                                                    <i class="ti ti-check"></i> Fitness programs
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="modern-health">
                                <div class="row g-0 h-100">
                                    <div className="col-md-6 order-md-2 position-relative d-flex justify-content-start">
                                        <div className="health-image-container position-relative">
                                            <div className="health-background-block bg-purple position-absolute"></div>
                                            <img src={Social} alt="Social Service" className="health-image position-relative" />
                                        </div>
                                    </div>
                                    <div class="col-md-6 order-md-1">
                                        <div class="health-content px-5 py-3">
                                            <div class="health-icon mb-3">
                                                <i class="ti ti-heart-handshake"></i>
                                            </div>
                                            <h3 class="fw-bold mb-3">Social Service Initiatives</h3>
                                            <p class="mb-4">Opportunities for community service and social outreach programs enable students to contribute positively to society while developing empathy and leadership skills.</p>

                                            <div class="health-highlights mb-3">
                                                <div class="health-highlight-item">
                                                    <i class="ti ti-check"></i> Rural development projects
                                                </div>
                                                <div class="health-highlight-item">
                                                    <i class="ti ti-check"></i> Environmental campaigns
                                                </div>
                                                <div class="health-highlight-item">
                                                    <i class="ti ti-check"></i> Educational outreach
                                                </div>
                                                <div class="health-highlight-item">
                                                    <i class="ti ti-check"></i> Charity drives
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="ptb-50 bg-white">
                <div class="container-xxl">
                    <div class="text-center mb-5">
                        <h2 class="section-title modern-title text-blue mt-3">Innovation, Entrepreneurship & Skill Development</h2>
                        <p class="section-subtitle mx-auto">Building career-oriented skills and fostering innovative thinking for the future</p>
                    </div>

                    <div class="row g-4">
                        <div class="col-lg-4 col-12">
                            <div class="innovation-card h-100">
                                <div class="innovation-icon">
                                    <i class="ti ti-cpu"></i>
                                </div>
                                <h3 class="fw-bold mb-3">Technical Clubs</h3>
                                <p class="mb-4">These clubs allow students to explore interests in technology and engineering through workshops, competitions, and projects, fostering innovation and skill development.</p>

                                <ul class="innovation-features">
                                    <li><i class="ti ti-check text-purple"></i> Coding competitions</li>
                                    <li><i class="ti ti-check text-purple"></i> Hackathons</li>
                                    <li><i class="ti ti-check text-purple"></i> Robotics workshops</li>
                                    <li><i class="ti ti-check text-purple"></i> Tech conferences</li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-lg-4 col-12">
                            <div class="innovation-card h-100">
                                <div class="innovation-icon">
                                    <i class="ti ti-building-skyscraper"></i>
                                </div>
                                <h3 class="fw-bold mb-3">Entrepreneurship Development</h3>
                                <p class="mb-4">Programs and clubs focused on entrepreneurship help students cultivate business ideas, network with industry professionals, and participate in startup competitions.</p>

                                <ul class="innovation-features">
                                    <li><i class="ti ti-check text-purple"></i> Startup incubator</li>
                                    <li><i class="ti ti-check text-purple"></i> Pitch competitions</li>
                                    <li><i class="ti ti-check text-purple"></i> Mentor sessions</li>
                                    <li><i class="ti ti-check text-purple"></i> Funding opportunities</li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-lg-4 col-12">
                            <div class="innovation-card h-100">
                                <div class="innovation-icon">
                                    <i class="ti ti-presentation"></i>
                                </div>
                                <h3 class="fw-bold mb-3">Workshops & Seminars</h3>
                                <p class="mb-4">Regular workshops and seminars featuring guest speakers from various fields provide students with insights and knowledge beyond their academic curriculum.</p>

                                <ul class="innovation-features">
                                    <li><i class="ti ti-check text-purple"></i> Industry experts</li>
                                    <li><i class="ti ti-check text-purple"></i> Skill-building sessions</li>
                                    <li><i class="ti ti-check text-purple"></i> Career guidance</li>
                                    <li><i class="ti ti-check text-purple"></i> Networking events</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default ExtraCurricular;
